import React from "react";
import Footer from "../components/Shared/Footer";
import Navbar from "../components/NavBar/Navbar";
import AboutSection from "../components/About_Page/AboutSection";
import Breadcrumbs from "../components/Article_Display_Page/Breadcrumbs";
import { useTheme } from "@mui/material/styles";


function About() {
const theme = useTheme();

  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
      <Navbar />
      <Breadcrumbs title={"Informacje"} />
      <AboutSection />
      <Footer />
    </div>
  );
}

export default About;